/** How the listed domains are read: what a wildcard covers, or that none is listed. */
export function domainScopeRule(domains: readonly string[]): string {
  return domains.some((domain) => domain.startsWith('*.'))
    ? 'each leftmost wildcard covers all subdomains at any depth, but not its base domain; list the base domain separately'
    : 'no wildcard pattern is listed; subdomains must be listed separately';
}

export function authorizedDomainScope(domains: readonly string[]): string {
  const listed = domains.join(', ') || 'No domain scope recorded';
  if (!domains.length) return listed;
  return `${listed} — ${domainScopeRule(domains)}`;
}

export function authorizedScopeSummary(
  scope:
    { scopeDomains?: readonly string[]; scopeIpAddresses?: readonly string[] } | null | undefined,
  fallback: string,
): string {
  const domains = scope?.scopeDomains ?? [];
  const parts = [
    domains.length ? authorizedDomainScope(domains) : '',
    scope?.scopeIpAddresses?.length ? `IPs ${scope.scopeIpAddresses.join(', ')}` : '',
  ].filter(Boolean);
  return parts.length ? parts.join(' · ') : fallback;
}
